<ng-container *ngLet="langChange$ | async">
  <form [ngClass]="filterContainer" [formGroup]="filterForm" (ngSubmit)="onSubmit()" *ngLet="disableObserver$ | async">
    <div class="mt16 mobile">
      <mat-radio-group aria-label="Select an option" formControlName="newRecommendedFavorites">
        <mat-radio-button class="mr24" [value]="'all'">{{ 'DATA.TABLE_FILTER.ALL' | translate }}</mat-radio-button>
        <mat-radio-button class="mr24" [value]="'new'">{{ 'DATA.TABLE_FILTER.NEW' | translate }}</mat-radio-button>
        <mat-radio-button class="mr24" [value]="'recommended'">{{ 'DATA.TABLE_FILTER.RECOMMENDED' | translate }}</mat-radio-button>
        <mat-radio-button class="mr24" [value]="'favorites'">{{ 'DATA.TABLE_FILTER.FAVORITES' | translate }}</mat-radio-button>
      </mat-radio-group>
      <div class="horizontal-line mt18"></div>
    </div>

    <div class="mt16">
      <span class="title mt16 mb10">{{ 'DATA.TABLE_FILTER.SET_TYPE' | translate }}:</span>
      <mat-radio-group aria-label="Select an option" formControlName="datasetType">
        <mat-radio-button class="mr24" [value]="null">{{ 'DATA.TABLE_FILTER.ALL' | translate }}</mat-radio-button>
        <mat-radio-button class="mr24" [value]="false">{{ 'LAYOUT.DATA' | translate }}</mat-radio-button>
        <mat-radio-button class="mr24" [value]="true">{{ 'DATA.TABLE_FILTER.CLASSIFIERS' | translate }}</mat-radio-button>
      </mat-radio-group>
      <div class="horizontal-line mt18"></div>
    </div>
    <div class="mt16">
      <span class="title mt16 mb10">{{ 'DATA.TABLE_FILTER.DATASET_STATUS' | translate }}:</span>
      <div class="checkbox-group">
        <mat-checkbox class="mr28" [disabled]="!filterForm.get('archiveStatus')?.value" formControlName="activeStatus">{{
          'OTHER.ACTIVE' | translate
        }}</mat-checkbox>
        <mat-checkbox class="mr28" [disabled]="!filterForm.get('activeStatus')?.value" formControlName="archiveStatus">{{
          'OTHER.ARCHIVES' | translate
        }}</mat-checkbox>
      </div>
      <div class="horizontal-line mt18"></div>
    </div>
    <div class="data-group">
      <div class="data">
        <span class="title mt16 mb10 data-group-title">{{ 'DATA.TABLE_FILTER.DATA' | translate }}</span>
        <div class="data-filter mt12">
          <span class="title mb10">{{ 'DATA.TABLE_HEADER.CATEGORY' | translate }}:</span>
          <mat-checkbox formControlName="accessibility">{{ 'DATA.TABLE_FILTER.ACCESSIBILITY' | translate }}</mat-checkbox>

          <span class="title mb10 mt16">{{ 'DATA.TABLE_FILTER.DATASETS_FOR_SPORTS_AND_REST' | translate }}:</span>
          <mat-checkbox formControlName="summerSeason">{{ 'DATA.TABLE_FILTER.SUMMER' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="winterSeason">{{ 'DATA.TABLE_FILTER.WINTER' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="allSeasons">{{ 'DATA.TABLE_FILTER.ALL_SEASON' | translate }}</mat-checkbox>
        </div>
      </div>
      <div class="data-card">
        <div class="data-filter" >
          <span class="title mb10" *ngIf="isRuLocale">{{ 'DATA.TABLE_FILTER.MAP_VIEW' | translate }}:</span>
          <mat-checkbox *ngIf="isRuLocale" formControlName="withMap" (change)="chooseMapFilter('withoutMap')">{{
            'DATA.TABLE_FILTER.WITH_MAP' | translate
          }}</mat-checkbox>
          <mat-checkbox *ngIf="isRuLocale" formControlName="withoutMap" (change)="chooseMapFilter('withMap')">{{
            'DATA.TABLE_FILTER.WITHOUT_MAP' | translate
          }}</mat-checkbox>

          <span [class.mt16]="isRuLocale" class="title mb10">{{ 'DATA.TABLE_FILTER.STATIC_DATA' | translate }}:</span>
          <mat-checkbox formControlName="iso">{{ 'DATA.TABLE_FILTER.ISO37120_AND_U4SSC_INDICATORS' | translate }}</mat-checkbox>
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div class="data-filter">
      <span class="title data-group-title mt16 mb10">{{ 'DATA.TABLE_FILTER.CLASSIFIERS_BIG' | translate }}</span>
      <span class="title mb10">{{ 'DATA.TABLE_FILTER.CLASSIFIERS_TYPE' | translate }}:</span>
      <mat-checkbox formControlName="ordinaryDict">{{ 'DATA.TABLE_FILTER.STANDARD' | translate }}</mat-checkbox>
      <mat-checkbox formControlName="regionalDict">{{ 'DATA.TABLE_FILTER.REGIONAL' | translate }}</mat-checkbox>
      <mat-checkbox formControlName="federalDict">{{ 'DATA.TABLE_FILTER.FEDERAL' | translate }}</mat-checkbox>
    </div>
    <div class="button-footer">
      <div class="container-button">
        <button class="btn-secondary medium mr12" (click)="reset()" type="button">{{ 'OTHER.RESET_ALL' | translate }}</button>
        <button class="btn-primary medium" type="submit">{{ 'OTHER.APPLY' | translate }}</button>
      </div>
    </div>
  </form>
</ng-container>
